// extracted by mini-css-extract-plugin
module.exports = {"Layout":"styles_Layout__MeIkn","Footer":"styles_Footer__1insh","bgWrapper":"styles_bgWrapper__2R-yk"};